import React, { useEffect } from 'react'
import { getStoreIdValue } from '../hooks/geturlstoreid'

const loadChatbotScript = () => {
  console.log('[Chatbot] LOADING...')
  const storeId = getStoreIdValue()

  if (!storeId) {
    console.warn('Chatbot script not loaded: store_id is missing.')
    return
  }

  // Remove existing script
  deleteChatbotScript()

  const newScript = document.createElement('script')
  newScript.src = `${process.env.REACT_APP_API_URL}/js/loader.bundle.js`
  newScript.id = 'chatbot-script-loader'
  newScript.setAttribute('data-store-id', storeId)
  newScript.defer = true

  document.body.appendChild(newScript)
  console.log('[Chatbot] LOADED.')
}

export const deleteChatbotScript = () => {
  const chatbotBody = document.querySelector('mag-chatbot')
  if (chatbotBody) chatbotBody.remove()

  const existingScript = document.getElementById('chatbot-script-loader')
  if (existingScript) existingScript.remove()

  console.info('[Chatbot] Script and bot cleaned up.')
}

const ChatbotLoader = () => {
  useEffect(() => {
    loadChatbotScript()

    // Cleanup when component unmounts (page change)
    return () => {
      deleteChatbotScript()
    }
  }, [])

  return null
}

// Export rebuild function to trigger programmatically
export function rebuildChatbot () {
  console.log('[Chatbot] REBUILD.')
  loadChatbotScript()
  window.chatbotConfig.open = true
}

export default ChatbotLoader
